<script>
import simplebar from "simplebar-vue";

import SideNav from "./side-nav";

export default {
  components: { simplebar, SideNav },
  props: {
    isCondensed: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasReportPermission() {
      return this.currentAccountHasPermissions(["ORGANIZATION_INFORMATION_TECHNOLOGY_AUDITOR"]);
    },

    hasPolicyPermission() {
      return this.hasRiskPermission;
    },
    hasFileManagerPermission() {
      return this.currentAccountHasPermissions(["ORGANIZATION_INFORMATION_TECHNOLOGY_AUDITOR"]);
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
      widthss: this.$store ? this.$store.state.layout.layoutWidth : {} || {},
    };
  },
  methods: {},
  mounted() {},
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar");
              document.body.removeAttribute("data-sidebar-size");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "dark");
              document.body.removeAttribute("data-sidebar");
              document.body.removeAttribute("data-sidebar-size");
              document.body.classList.remove("vertical-collpsed");
              break;
            case "compact":
              document.body.setAttribute("data-sidebar-size", "small");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "icon":
              document.body.setAttribute("data-keep-enlarged", "true");
              document.body.classList.add("vertical-collpsed");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "colored":
              document.body.setAttribute("data-sidebar", "colored");
              document.body.removeAttribute("data-keep-enlarged");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-sidebar-size");
              break;
            default:
              document.body.setAttribute("data-sidebar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="vertical-menu2 d-flex flex-column" style="background-color: rgb(243, 246, 248);">
    <div class="sidebar--logo">
      <img :src="whiteLabel || require('@/assets/images/logo.png')" height="52" alt="" />
    </div>

    <router-link tag="a" to="/fwsed/dashboard">
      <div class="menu-item">
        <i class="iconoir-dashboard-speed"></i>
        {{ $t("common.dashboard") }}
      </div>
    </router-link>

    <router-link tag="a" to="/fwsed/firm">
      <div class="menu-item">
        <i class="iconoir-community"></i>
        {{ $t("firm.menu") }}
      </div>
    </router-link>

    <router-link tag="a" to="/fwsed/firm-management">
      <div class="menu-item">
        <i class="iconoir-shield-check"></i>
        {{ $t("firm.management") }}
      </div>
    </router-link>

    <router-link v-if="hasFileManagerPermission" tag="a" to="/fwsed/file-manager">
      <div class="menu-item">
        <i class="bx bx-folder-open folder-icon"></i>
        {{ $t("file-manager.text") }}
      </div>
    </router-link>
    <hr />
    <a href="/">
      <div class="menu-item">
        <i class="iconoir-view-grid"></i>
        {{ $t("dashboard.text") }}
      </div>
    </a>
    <a href="/organization">
      <div class="menu-item">
        <i class="iconoir-cube-hole"></i>
        {{ $t("organization.panel") }}
      </div>
    </a>

    <a v-if="hasOrganizationAccessableForProduct(currentOrganization, 'AUDIT_CONTROL')" href="/audit-control/compliance">
      <div class="menu-item">
        <img src="/icons/audit-control-active.svg" width="24" height="24" alt="" />
        {{ $t("product.audit-control.product") }}
      </div>
    </a>
    <a v-if="hasOrganizationAccessableForProduct(currentOrganization, 'FINDING')" href="/finding/view">
      <div class="menu-item">
        <img src="/icons/finding-active.svg" width="24" height="24" alt="" />
        {{ $t("product.finding.product") }}
      </div>
    </a>
    <a v-if="hasOrganizationAccessableForProduct(currentOrganization, 'TASK')" href="/tasks/dashboard">
      <div class="menu-item ">
        <i class="bx bx-task text-main"></i>
        {{ $t("product.task.product") }}
      </div>
    </a>
    <a v-if="hasOrganizationAccessableForProduct(currentOrganization, 'RISK')" href="/risk/dashboard">
      <div class="menu-item">
        <img src="/icons/risk-active.svg" width="24" height="24" alt="" />
        {{ $t("product.risk.product") }}
      </div>
    </a>
  </div>
</template>

<style lang="scss" scoped>
.user-panel {
  display: flex;
  align-items: center;
  padding-left: 1.5rem;
  gap: 1rem;
  color: #707070;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 3.38rem;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 1rem;
  color: #535a71;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  max-width: 15rem;
  width: 100%;
  border-radius: 0.625rem;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  transition: background-color, color, 0.3s;
  cursor: pointer;

  i {
    position: relative;
    bottom: 1px;
    font-size: 1.5rem;
  }

  &:hover {
    background: #f2e0da;
    color: #ff7c48;

    i {
      color: #ff7c48;
    }
  }
}

.active {
  .menu-item {
    background: #f2e0da;
    color: #ff7c48;

    i {
      color: #ff7c48;
    }
  }
}
</style>
